import { RefreshCw } from 'lucide-react';

// iter830 — Live menu-updated banner. Shown when the
// /cashier/menu-version probe detects an out-of-band change
// (manager tweaked a price/VAT flag in another tab). One tap
// refetches menu/categories/tax so the cart calc is
// immediately based on the new data.
export const MenuUpdatedBanner = ({ onRefresh }) => (
  <button
    type="button"
    className="mx-3 sm:mx-4 mt-2 flex items-center gap-2 rounded-lg border border-amber-300 bg-amber-50 dark:bg-amber-950/30 px-3 py-2 text-left hover:bg-amber-100 dark:hover:bg-amber-900/40 transition-colors shadow-sm animate-in fade-in slide-in-from-top-2"
    onClick={onRefresh}
    data-testid="menu-updated-banner"
  >
    <div className="w-7 h-7 rounded-full bg-amber-200 dark:bg-amber-800/60 flex items-center justify-center shrink-0">
      <RefreshCw size={14} className="text-amber-800 dark:text-amber-200" />
    </div>
    <div className="flex-1 min-w-0">
      <div className="text-xs font-bold text-amber-900 dark:text-amber-100">Menu updated</div>
      <div className="text-[10px] text-amber-800/80 dark:text-amber-200/80 truncate">
        A manager changed a menu item — tap to refresh prices &amp; VAT before ringing up
      </div>
    </div>
    <div className="text-[10px] font-semibold text-amber-800 dark:text-amber-200 shrink-0">Refresh</div>
  </button>
);

export default MenuUpdatedBanner;
